import React from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import style from "./index.module.css";

import { getPermissionAccess } from "@/utils";

import { IRolePermissionAccess, IModalKeyEnums } from "@/models/permission";

import { useAppSelector } from "@/store/hooks";
import { rolePermission } from "@/store/slices/permission";

interface IProps {
  moduleKey: IModalKeyEnums;
  featureKey: string;
  children: React.ReactNode;
  isCenter?: boolean;
  showEmptyChild?: boolean;
  isVisible?: boolean;
}
const PermissionWrapper = (props: IProps) => {
  const {
    moduleKey,
    featureKey,
    children,
    isCenter = true,
    showEmptyChild = false,
    isVisible = true,
  } = props;
  const { permission } = useAppSelector(rolePermission);

  const permissionAccess = getPermissionAccess(
    moduleKey,
    featureKey,
    permission
  );

  if (
    showEmptyChild &&
    permissionAccess === IRolePermissionAccess.NOT_ACCESSIBLE
  ) {
    return <></>;
  }

  if (permissionAccess === IRolePermissionAccess.NOT_ACCESSIBLE) {
    return (
      <Grid item className={isCenter ? style.permissionContainer : ""}>
        <Typography component={"p"} sx={{ textAlign: "center" }}>
          {isVisible && (
            <FormattedMessage
              id="permission_access"
              defaultMessage="ou are not authorized to perform this action, Please contact your administrator"
            />
          )}
        </Typography>
      </Grid>
    );
  }
  return <>{children}</>;
};

export default PermissionWrapper;
